/**
 * Mercado Público entrega nombres como "RAZON SOCIAL S A | Nombre fantasía".
 * Para la UI se muestra un solo nombre legible y el completo queda como tooltip.
 */
export function nombreCorto(valor: string | null | undefined): string {
  if (!valor) return "";
  const partes = valor
    .split("|")
    .map((p) => p.trim())
    .filter(Boolean);
  if (partes.length === 0) return valor.trim();
  if (partes.length === 1) return partes[0];

  const normalizar = (s: string) => s.toLowerCase().replace(/[^a-z0-9]/g, "");
  // Si ambas partes son el mismo nombre (mayúsculas vs. capitalizado), toma la más legible.
  if (normalizar(partes[0]) === normalizar(partes[1])) {
    const esTodoMayuscula = partes[0] === partes[0].toUpperCase();
    return esTodoMayuscula ? partes[1] : partes[0];
  }
  // Nombre de fantasía primero: suele ser el más corto y reconocible.
  return partes[1].length <= partes[0].length ? partes[1] : partes[0];
}
